module.exports = __webpack_public_path__ + "img/edit.5b75b03e.svg";